import React from 'react';
import PropTypes from 'prop-types';
import { graphql, compose } from 'react-apollo';
import { FormattedMessage, injectIntl, intlShape } from 'react-intl';
import { Container, Grid, Header } from 'semantic-ui-react';
import { default as getObjectProperty } from 'lodash.get';

import { Wrappers, ErrorCard, PageLoader, PageHeader } from '../../components';
import { withAnalytics, withPageViewTracking } from '../../analytics';
import { withNavigator } from '../../routing';
import { withAuth, authProptypes } from '../../auth';
import { ApiStatuses, Queries } from '../../api';
import { withManuals } from '../../hoc';
import { GridNumbers } from '../../utils';

import JustLaunched from './JustLaunched';
import BottomPromos from './BottomPromos';
import Announcements from './Announcements';

import Tools from './Tools';
import { HeaderBanner, HeaderSubtitle } from './Landing.style';

// const analyticsEventName = 'Tool Selected';

const Landing = ({
  // intl,
  // navigator,
  // analytics,
  apiStatus,
  authUser,
  brand: manualData,
  partsBrands,
  allBrands,
  landingData
}) => {
  const isAuthorized = authUser && authUser.isAuthorized;

  const manualBrands = manualData
    ? manualData.map(brand => ({
        ...brand,
        name: brand.Name,
        url: `/manuals/${brand.Name}`
      }))
    : [];

  const formatWelcomeDate = date => {
    const newDate = new Date(date);
    const month = newDate.toLocaleString('default', {
      month: 'short'
    });
    const day = newDate.getDate();
    const year = newDate.getFullYear();

    return `${month} ${day}, ${year}`;
  };

  if (!isAuthorized) {
    return (
      <Wrappers.Layout>
        <ErrorCard
          title={<FormattedMessage id="title.issue" />}
          description={
            <FormattedMessage
              id="description.issue"
              values={{
                break: (<br />),
                email: (
                  <a href="mailto:agidealersupport@aggrowth.com">
                    agidealersupport@aggrowth.com
                  </a>
                )
              }}
            />
          }
          showLink={false}
          qa="sorry-no-access"
        />
      </Wrappers.Layout>
    );
  }

  const { lastVisit, givenName } = authUser;
  const welcomeText = `Welcome ${lastVisit ? 'Back' : ''} ${givenName},`;
  const formattedLastVisit = `Last visit on ${formatWelcomeDate(lastVisit)}`;
  return (
    <Wrappers.Layout menu>
      <Container as="main">
        <Grid>
          <Grid.Column>
            {apiStatus === ApiStatuses.Loading && <PageLoader />}
            <PageHeader overlap>
              <HeaderBanner>
                <Header as="h1">{welcomeText}</Header>
                <HeaderSubtitle>
                  {lastVisit && formattedLastVisit}
                </HeaderSubtitle>
              </HeaderBanner>
            </PageHeader>

            <Grid>
              {landingData && landingData.carousel && (
                <Grid.Column
                  mobile={GridNumbers.base}
                  tablet={GridNumbers.base}
                  computer={10}
                  largeScreen={10}
                  widescreen={8}
                >
                  <JustLaunched data={landingData.carousel} />
                </Grid.Column>
              )}
              {landingData && landingData.announcements && (
                <Grid.Column
                  mobile={GridNumbers.base}
                  tablet={GridNumbers.base}
                  computer={6}
                  largeScreen={6}
                  widescreen={8}
                >
                  <Announcements data={landingData.announcements} />
                </Grid.Column>
              )}
            </Grid>
            <Tools
              manualBrands={manualBrands}
              partsBrands={partsBrands}
              allBrands={allBrands}
              toolPermissions={authUser.tools}
              authUser={authUser}
            />
            <Grid>
              <Grid.Column
                mobile={GridNumbers.base}
                computer={GridNumbers.base}
              />
            </Grid>
            {landingData &&
              landingData.bottomPromo &&
              landingData.bottomPromo.length >= 1 && (
                <BottomPromos data={landingData.bottomPromo} />
              )}
          </Grid.Column>
        </Grid>
      </Container>
    </Wrappers.Layout>
  );
};

Landing.propTypes = {
  intl: intlShape.isRequired,
  navigator: PropTypes.object,
  apiStatus: ApiStatuses.propType,
  authUser: authProptypes.user,
  error: PropTypes.string,
  newsItems: PropTypes.array,
  analytics: PropTypes.object,
  partsBrands: PropTypes.array,
  brands: PropTypes.array, // comes from withManuals API
  brand: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  landingData: PropTypes.object
};

export default compose(
  graphql(Queries.getLandingPage, {
    props: props => {
      return {
        ...props,
        landingData: getObjectProperty(props, 'data.getLandingPage', undefined)
      };
    }
  }),
  graphql(Queries.getBrands, {
    props: props => {
      const allBrands = getObjectProperty(props, 'data.getBrands', undefined);
      const partsBrands =
        allBrands && allBrands.filter(brand => !!brand.partsUrl);

      return {
        ...props,
        partsBrands,
        allBrands
      };
    }
  }),
  injectIntl,
  withNavigator,
  withAuth,
  withManuals,
  withAnalytics,
  withPageViewTracking()
)(Landing);



// WEBPACK FOOTER //
// ./src/pages/Landing/index.js